module.exports = __webpack_public_path__ + "img/supplierSignup.3bf1fe76.png";